export default "__VITE_ASSET__Dwge2u1d__"